import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { AirSegmentDetails } from '../../../../../../models/itinerary';
import { AppState } from '../../../../../../store/model';
import {
  getDiffDays,
  getOvernightLabelText,
} from '../../../../../../store/reducers/segment-details/reducer';
import { getSegmentOption } from '../../../../../../store/reducers/segment-options/selectors';
import { AirRoute as AirRouteLab } from '../../../../../lab/Route/AirRoute';

interface OwnProps {
  optionId: string;
  segmentId: number;
}

interface StateProps {
  arrivalCityCode: AirSegmentDetails['arrivalCityCode'];
  arrivalCityName: AirSegmentDetails['arrivalCityName'];
  arrivalDate: AirSegmentDetails['arrivalDate'];
  departureCityCode: AirSegmentDetails['departureCityCode'];
  departureCityName: AirSegmentDetails['departureCityName'];
  departureDate: AirSegmentDetails['departureDate'];
  stops: AirSegmentDetails['stops'];
  legs: AirSegmentDetails['legs'];
  overnight?: string;
}

interface AirRouteProps extends StateProps {}

const mapStateToProps = (
  state: AppState,
  { optionId, segmentId }: OwnProps,
) => {
  const {
    arrivalCityCode,
    arrivalCityName,
    arrivalDate,
    departureDate,
    departureCityCode,
    departureCityName,
    stops,
    legs,
  } = getSegmentOption(segmentId, optionId)(state) as AirSegmentDetails;
  const overnight = getOvernightLabelText(
    getDiffDays(departureDate, arrivalDate),
  );

  return {
    arrivalCityCode,
    arrivalCityName,
    arrivalDate,
    departureCityCode,
    departureCityName,
    departureDate,
    stops,
    legs,
    overnight,
  };
};

const enhance = compose<AirRouteProps, OwnProps>(connect(mapStateToProps));

export const AirRoute = enhance(AirRouteLab);

AirRoute.displayName = 'AirRoute';
